import { render, staticRenderFns } from "./ViolationLayoutPreview.vue?vue&type=template&id=be61816c&scoped=true"
import script from "./ViolationLayoutPreview.vue?vue&type=script&lang=js"
export * from "./ViolationLayoutPreview.vue?vue&type=script&lang=js"
import style0 from "./ViolationLayoutPreview.vue?vue&type=style&index=0&id=be61816c&prod&scoped=true&lang=css"
import style1 from "./ViolationLayoutPreview.vue?vue&type=style&index=1&id=be61816c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be61816c",
  null
  
)

export default component.exports